import cn from 'classnames'

import { HTMLProps } from 'react'
import { IconPWLogo } from '~/components/icons/IconPWLogo'
// import { ClientOnly } from '@tanstack/react-router'
// import { ProductGallery } from '~/components/shared/ProductGallery'

// import PMCWide from '/images/logo/pmc-wide.svg?url'

interface FooterProps extends HTMLProps<HTMLDivElement>
{

}

export function Footer ({
    className,
    ...props
}: FooterProps)
{
    return (
        <div className={className}>
            {/*<div className={cn('w-full h-auto', 'md:hidden')}>*/}

            {/*    <IconPWLogo className={cn('w-full h-auto')} />*/}

            {/*</div>*/}
            <footer
                className={cn(
                    'pt-4 pb-6 px-4 border border-accent/10 rounded-lg',
                    'text-accent/60',
                    'md:px-6 md:py-3 md:border-0 md:rounded-0',
                    'md:bg-accent/5',
                )} {...props}>
                <nav
                    className={cn(
                        'flex flex-col items-center gap-3',
                        'md:flex-row md:justify-between md:items-center',
                    )}
                >
                    <ul className={cn('w-full', 'md:w-max')}>
                        <li className={cn('flex flex-row items-center gap-3')}>
                            <span className={cn('grow-0')}>Community</span>
                            <div className={cn('grow-1 flex flex-row items-center gap-0')}>
                                <span
                                    className={cn(
                                        'grow-1 h-[1px] border-t border-dashed border-accent/50',
                                        'md:min-w-17',
                                    )}
                                ></span> <span>&#9670;</span>
                            </div>
                            <span className={cn('grow-0')}>
                                <a
                                    href={'https://x.com/nikzh/status/1990826605346742399?utm_source=pmc'}
                                    rel={'external'}
                                    className={'underline underline-offset-[0.25em] decoration-current'}
                                >X/Twitter</a>
                            </span>
                        </li>
                    </ul>
                    <span>Version 0.2</span>
                </nav>
            </footer>

            <div className={cn('w-full')}>
                {/*// background: var(--Button_small_hover, radial-gradient(50% 50% at 50% 50%, rgba(11, 145, 15, 0.20) 47.6%, rgba(18, 247, 26, 0.20) 100%));*/}
                <ul
                    className={cn(
                        'w-full flex flex-row gap-0 flex-wrap *:basis-0 *:grow-1 *:shrink-0 *:min-w-70 *:bg-radial-[at_50%_50%] *:from-[rgba(11,145,15,0.20)] *:to-[rgba(18,247,26,0.20)] *:from-45% *:to-100% *:flex *:justify-stretch [&_a]:w-full font-sans')}
                >
                    <li>
                        <a
                            href={'https://blockchair.com/?from=pmc&utm_source=pmc'}
                            rel={'external'}
                            className={cn(
                                'flex flex-col justify-center px-6 py-3 hover:bg-accent hover:text-black transition-colors duration-100 ease-out')}
                        >
                            <div className={cn('flex flex-row items-center gap-2')}>
                                <span className={cn('font-medium text-xl')}>Blockchair</span>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11.9998 8.39995L18.2398 12M11.9998 8.39995L5.75977 12M11.9998 8.39995V1.19995L5.75977 4.79995V12M18.2398 12V19.2L11.9998 22.8M18.2398 12L11.9998 15.6M11.9998 22.8L5.75977 19.2L11.9998 15.6M11.9998 22.8V15.6M5.75977 12L11.9998 15.6"
                                        strokeWidth="1.2"
                                        strokeLinejoin="round"
                                        className={'stroke-current'}
                                    />
                                </svg>
                            </div>
                            <p className={cn('font-medium text-xs')}>Explore data stored on 48 blockchains</p>
                        </a>
                    </li>
                    <li>
                        <a
                            href={'https://3xpl.com/?from=pmc&utm_source=pmc'}
                            rel={'external'}
                            className={cn(
                                'flex flex-col justify-center px-6 py-3 hover:bg-accent hover:text-black transition-colors duration-100 ease-out')}
                        >
                            <div className={cn('flex flex-row items-center gap-2')}><span
                                className={cn('font-medium text-xl')}
                            >3xpl</span>
                                <svg
                                    width="17"
                                    height="24"
                                    viewBox="0 0 17 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_903_5791)">
                                        <path
                                            d="M0.504693 18.4688C0.217186 18.7563 0.217186 19.2224 0.504693 19.5099L4.16409 23.1693C4.45159 23.4568 4.91774 23.4568 5.20525 23.1693L8.86464 19.5099C9.15215 19.2224 9.15215 18.7563 8.86464 18.4688L5.20525 14.8094C4.91774 14.5219 4.45159 14.5219 4.16409 14.8094L0.504693 18.4688Z"
                                            className={'fill-current'}
                                        />
                                        <path
                                            d="M7.53594 12.4709C7.24844 12.1834 7.24844 11.7172 7.53594 11.4297L11.1953 7.77032C11.4828 7.48281 11.949 7.48281 12.2365 7.77032L15.8959 11.4297C16.1834 11.7172 16.1834 12.1834 15.8959 12.4709L12.2365 16.1303C11.949 16.4178 11.4828 16.4178 11.1953 16.1303L7.53594 12.4709Z"
                                            className={'fill-current'}
                                        />
                                        <path
                                            d="M0.504693 5.43962C0.217186 5.15211 0.217186 4.68597 0.504693 4.39846L4.16409 0.739068C4.45159 0.451561 4.91774 0.451561 5.20525 0.739068L8.86464 4.39846C9.15215 4.68597 9.15215 5.15211 8.86464 5.43962L5.20525 9.09901C4.91774 9.38652 4.45159 9.38652 4.16409 9.09901L0.504693 5.43962Z"
                                            className={'fill-current'}
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_903_5791">
                                            <rect width="16.8" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <p className={cn('font-medium text-xs')}>Fastest universal block explorer</p>
                        </a>
                    </li>
                    <li>
                        <a
                            href={'https://wow.cash/?from=pmc&utm_source=pmc'}
                            rel={'external'}
                            className={cn(
                                'flex flex-col justify-center px-6 py-3 hover:bg-accent hover:text-black transition-colors duration-100 ease-out')}
                        >
                            <div className={cn('flex flex-row items-center gap-2')}><span
                                className={cn('font-medium text-xl')}
                            >wow.cash</span>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3.52148 2.84888H19.6311C20.0993 2.84888 20.4789 3.22848 20.4789 3.69675V15.567C20.4789 16.0352 20.0993 16.4148 19.6311 16.4148H3.52148V2.84888Z"
                                        className={'fill-current'}
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2.67383 2.84787C2.67383 2.37961 3.05343 2 3.5217 2H19.6313C20.5678 2 21.327 2.75921 21.327 3.69575V15.566C21.327 16.5025 20.5678 17.2617 19.6313 17.2617H3.5217C3.05343 17.2617 2.67383 16.8821 2.67383 16.4138V2.84787ZM3.5217 2.84787V16.4138H19.6313C20.0996 16.4138 20.4792 16.0342 20.4792 15.566V3.69575C20.4792 3.22748 20.0996 2.84787 19.6313 2.84787H3.5217Z"
                                        fill="#0A0A0A"
                                    />
                                    <path
                                        d="M3.52148 2.84888L17.7129 7.85762C17.8462 7.90466 17.9353 8.03063 17.9353 8.17195V21.031C17.9353 21.2609 17.7079 21.4218 17.4911 21.3453L3.52148 16.4148V2.84888Z"
                                        fill="#51FF33"
                                        fillOpacity="0.4"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M3.52148 16.4148H17.9353V8.536C17.9353 8.17651 17.7086 7.8561 17.3696 7.73646L3.52148 2.84888V16.4148Z"
                                        className={'fill-current'}
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M18.3574 16.8364H3.0957V2.24731L17.5089 7.33432C18.0174 7.51379 18.3574 7.9944 18.3574 8.53363V16.8364ZM17.3678 7.73409C17.7068 7.85373 17.9335 8.17414 17.9335 8.53363V16.4125H3.51964V2.84651L17.3678 7.73409Z"
                                        fill="#0A0A0A"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2.67383 2.99769C2.67383 2.33952 3.3246 1.8791 3.94524 2.09815L17.652 6.93584C18.33 7.17513 18.7834 7.81595 18.7834 8.53492V20.3026C18.7834 21.4726 17.6266 22.2911 16.5233 21.9017L2.67383 17.0136V2.99769ZM3.5217 2.84779V16.4138L16.8055 21.1022C17.3571 21.2969 17.9355 20.8876 17.9355 20.3026V8.53492C17.9355 8.17543 17.7088 7.85502 17.3699 7.73538L3.5217 2.84779Z"
                                        fill="#0A0A0A"
                                    />
                                </svg>
                            </div>
                            <p className={cn('font-medium text-xs')}>Watch-only wallet to track assets without risk</p>
                        </a>
                    </li>
                    <li>
                        <a
                            href={'https://budget.day/?from=pmc&utm_source=pmc'}
                            rel={'external'}
                            className={cn(
                                'flex flex-col justify-center px-6 py-3 hover:bg-accent hover:text-black transition-colors duration-100 ease-out')}
                        >
                            <div className={cn('flex flex-row items-center gap-2')}><span
                                className={cn('font-medium text-xl')}
                            >budget.day</span>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect width="24" height="24" fill="url(#pattern0_903_5804)" />
                                    <defs>
                                        <pattern
                                            id="pattern0_903_5804"
                                            patternContentUnits="objectBoundingBox"
                                            width="1"
                                            height="1"
                                        >
                                            <use href="#image0_903_5804" transform="scale(0.0416667)" />
                                        </pattern>
                                        <image
                                            id="image0_903_5804"
                                            width="24"
                                            height="24"
                                            preserveAspectRatio="none"
                                            href="data:image/png;base64,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"
                                        />
                                    </defs>
                                </svg>
                            </div>
                            <p className={cn('font-medium text-xs')}>Bitcoin’s security budget issue</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}